(function () {
  var div_chatbot = document.createElement("div");
  document.getElementsByTagName("body")[0].appendChild(div_chatbot);
  var imgminchat = require("@/assets/new_chat_bot_logo.png");
  var link = process.env.VUE_APP_CHAT_BOT;

  div_chatbot.outerHTML =
    "<div id='botChat' style='border-radius: 10px;position: absolute; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; padding: 0px; border: 0px; background: transparent; overflow: hidden; position: fixed; z-index: 16000004; right: 20px; bottom: 30px;display: none; width: 535px; height: 520px; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 3px 2px;'><div id='botTitleBar' style='z-index: 16000005;height: 25px; width: 535px; position:fixed; cursor: pointer; border-top-left-radius: 10px; border-top-right-radius: 10px;'> <i class='fa fa-close' id='botCloseplugin' style='float: right;margin-top: 10px;color:white;margin-right: 10px;'></i></div><iframe id='iframechatbot' frameborder='0' style='background-color: transparent; vertical-align: text-bottom; position: relative; width: 100%; height: 100%; min-width: 100%; min-height: 100%; max-width: 100%; max-height: 100%; margin: 0px; overflow: hidden; display: block;'src='" +
    link +
    "'></iframe></div><div id='minBotChat' style='display:flex ; transition: width 0.5s ease, background-color 0.5s ease; cursor:pointer; border-radius: 10px 0 0 10px; margin-top: 0px; margin-right: -6px; margin-bottom: 0px; padding: 10px 10px 10px 20px; border: 0px; background: #E4E8EF;position: fixed; z-index: 16000002; width: 0px; height: 120px; right: 10px; bottom: 60px;'><span id='textChat' style='transform: rotate(-90deg); color: #517871; font-weight: bold; font-size: 20px; margin-left: 6px; font-family: Noto Sans Thai !important;'>CHAT</span><span style='width: 2px; height: auto; background-color: white; color: white; margin-left: -45px;'></span><div id='frameLogo' style='z-index: 16000005; width: 90px; height: 90px; background:white; border-radius:50px; margin: 6px 0 0 12px; padding: 6px 16px 6px 16px;'><img id='ChatbotImage' src='" +
    imgminchat +
    "' style='z-index: 16000005; display:none; width: 100%;height: 100%;  transition: opacity 0.5s ease; opacity: 0;'/></div></div>";

    const mediaQueryCondition = window.matchMedia("(max-width: 565px)");

    document.querySelector("body").addEventListener("click", function (e) {
      e.target.matches = e.target.matches || e.target.msMatchesSelector;
  
      if (e.target.matches("#botCloseplugin")) {
        document.getElementById("botChat").style.display = "none";
        document.getElementById("ChatbotImage").style.display = "none";
        document.getElementById("minBotChat").style.width = "0px";
      } else if (e.target.matches("#minBotChat") || e.target.matches("#textChat")) {
        var minBotChat = document.getElementById("minBotChat");
        var chatBotImage = document.getElementById("ChatbotImage");
  
 
        if (minBotChat.style.width === "160px") {
          chatBotImage.style.opacity = "0";
          setTimeout(() => {
            chatBotImage.style.display = "none";
          }, 400);
          minBotChat.style.width = "0px";
        } else {
          chatBotImage.style.display = "block";
          setTimeout(() => {
            chatBotImage.style.opacity = "1";
          }, 10); 
          minBotChat.style.width = "160px";
        }
      } else if (e.target.matches("#ChatbotImage") || (e.target.matches("#frameLogo"))) {
        if (mediaQueryCondition.matches) {
          document.getElementById("botChat").style.width = "calc(100vw - 40px)";
          document.getElementById("botTitleBar").style.width = "calc(100vw - 40px)";
        }
        document.getElementById("botChat").style.display = "block";
        document.getElementById("minBotChat").style.width = "160px";
      }
    });
  dragElement(document.getElementById("botChat"));

  function dragElement(elmnt) {
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    if (document.getElementById("botTitleBar")) {
      /* if present, the header is where you move the DIV from:*/
      document.getElementById("botTitleBar").onmousedown = dragMouseDown;
    } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }
}())